import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { RouterProvider } from 'react-router-dom';
import './i18n';
import './styles/index.scss';
import 'typeface-roboto';
import AppWrapper from './AppWrapper';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ConfirmDialogProvider } from './context/ConfirmDialogProvider';
import { OverlayProvider } from './context/OverlayProvider';
import { useDynamicRouter } from './routes';
import { useAppSelector } from './types/hooks';
import { userId$ } from './store/slices/user';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const AppInner = () => {
    const userId = useAppSelector(userId$);

    const router = useDynamicRouter(userId);

    return <RouterProvider router={router} />;
};

const App = () => {
    return (
        <>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ConfirmDialogProvider>
                        <OverlayProvider>
                            <AppInner />
                            <AppWrapper />
                        </OverlayProvider>
                        <ToastContainer pauseOnFocusLoss={false} position="top-center" limit={3} autoClose={2500} />
                    </ConfirmDialogProvider>
                </PersistGate>
            </Provider>
        </>
    );
};

root.render(<App />);

reportWebVitals();
